export const formatCurrency = (value: string) => {
  if (!value || value === '' || value === '0') {
    return '';
  }

  const cleanValue = value.replace(/\D/g, '');
  if (!cleanValue) {
    return '';
  }

  const number = parseInt(cleanValue, 10);

  if (isNaN(number) || number === 0) {
    return '';
  }

  return number.toLocaleString('es-MX');
};

export const formatPhone = (value: string) => {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  if (digits.length <= 2) {
    return digits;
  } else if (digits.length <= 6) {
    return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  } else if (digits.length <= 10) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
  }

  return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6, 10)}`;
};
